export default {
  items: [], // array of objects, each item mush contain at least `src` and `_id`
  currentIndex: null,
  meta: {},
};
